import { Star } from "lucide-react";
import { useLang } from "@/context";
import { Reveal } from "./Reveal";

export const Reviews = () => {
    const { t } = useLang();
    return (
        <section id="reviews" data-testid="reviews-section" className="py-20 sm:py-24 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="text-center max-w-2xl mx-auto">
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#2A0505]">{t.reviews.heading}</h2>
                    <div className="mt-10 rounded-3xl border-2 border-dashed border-[#EADFD8] bg-[#FBF7F3] p-10 sm:p-14">
                        <div className="flex justify-center gap-1.5">
                            {[0, 1, 2, 3, 4].map((i) => (
                                <Star key={i} className="w-6 h-6 text-[#C9A24B]" fill="none" strokeWidth={1.5} />
                            ))}
                        </div>
                        <h3 className="font-display text-2xl font-bold text-[#2A0505] mt-6">{t.reviews.title}</h3>
                        <p className="text-sm sm:text-base text-[#6B5B57] mt-3 max-w-md mx-auto leading-relaxed">{t.reviews.text}</p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
